import api from "./axios";

export const getAllTeamsApi = () => api.get("/teams");
export const getTeamByIdApi = (id) => api.get(`/teams/${id}`);
export const createTeamApi = (data) => api.post("/teams", data);
export const updateTeamApi = (id, data) => api.put(`/teams/${id}`, data);
export const deleteTeamApi = (id) => api.delete(`/teams/${id}`);
